<section class="company-registration-card" data-cy="company-registration-card">
  <header class="company-registration-card__header">
    <h2 class="company-registration-card__title">Cadastro</h2>
    <span class="company-registration-card__hint">Somente leitura</span>
  </header>

  <app-onboarding-company-information
    class="w-100"
    [disabled]="true"
    [hasSaveButton]="false"
    [onboardingCompanyInformation]="onboardingCompanyInformation"
    (sendSaveCompanyInfo)="saveCompanyInfo.emit($event)">
  </app-onboarding-company-information>
</section>
